import { render, staticRenderFns } from "./AuthForgotPasswordModal.vue?vue&type=template&id=d2c76f18&scoped=true&"
import script from "./AuthForgotPasswordModal.vue?vue&type=script&lang=js&"
export * from "./AuthForgotPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthForgotPasswordModal.vue?vue&type=style&index=0&id=d2c76f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c76f18",
  null
  
)

export default component.exports